import { faExpandWide, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import { KCFColor } from 'styles/themes/KCFColor';

export type FullScreenIconProps = {
    /**
     * Icon to display.
     */
    icon?: IconDefinition;
    /**
     * Color of the icon.
     */
    color?: string;
    /**
     * The `aria-label` to apply.
     */
    ariaLabel?: string;
    /**
     * The title attribute to apply to the icon.
     */
    title?: string;
    /**
     * Classes to apply to the icon element.
     */
    className?: string;
} & Pick<FontAwesomeIconProps, 'size' | 'aria-hidden' | 'aria-label'>;

function FullScreenIcon({
    size,
    icon,
    className,
    color,
    title,
    'aria-hidden': ariaHidden,
    'aria-label': ariaLabel,
}: FullScreenIconProps) {
    const commonProps = {
        className,
        'aria-hidden': ariaHidden,
    };

    return (
        <FontAwesomeIcon
            {...commonProps}
            icon={icon ?? faExpandWide}
            color={color ?? KCFColor.black}
            title={title ?? 'Full Size'}
            aria-label={ariaLabel ?? 'Full Size'}
            size={size ?? size}
        />
    );
}
const memoFullScreenIcon = memo(FullScreenIcon);
export { memoFullScreenIcon as FullScreenIcon };
